import Splide from '@splidejs/splide';

const EL = '.js-people';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    pagination: false,
    arrows: true,
    fixedWidth: '290px',
    gap: 40,
    breakpoints: {
      1024: {
        fixedWidth: '220px',
        gap: 20,
      },
      767: {
        gap: 10,
      },
    },
  }).mount();
}
